const titles = {
    action: "פעולה",
    addSuccessfully: "נוסף בהצלחה",
    updateSuccessfully: "עודכן בהצלחה",
    errorMessage: "אופס, משהו השתבש, נסה שוב",
    LoginerrorMessage: "אופס, משהו השתבש, אנא התחבר שוב",
    deletedSuccess: "נמחק בהצלחה",
    go_back: "חזור",
    otpVerifiedMsg: "קוד אימות אומת בהצלחה!",
    otpSentSuccessMsg: "קוד אימות נשלח בהצלחה!",
    registerSuccessMsg: "נרשמת בהצלחה!",
    areYouSureWantToLogout: "האם אתה בטוח שברצונך להתנתק?",
    successLogin: "נכנסת בהצלחה",
    update: "עדכן",
    save: "שמור",
    item: "פריט",
    profile: "פרופיל",
    dashboard: "לוח בקרה",
    enterToSearch: "הזן לחיפוש",
    email: "אימייל",
    phone: "טלפון",
    openVolunteering: "התנדבות פתוחה",
    myVolunteerBasket: "סל ההתנדבות שלי",
    newHelpRequest: "בקשת עזרה חדשה",
    userManagement: "ניהול משתמשים",
    volunteersManagement: "ניהול מתנדבים",
    notificationLog: "יומן התראות",
    aboutUs: "אודותינו",
    instructions: "הנחיות",
    regulations: "תקנות",
    accessibilityStatement: "הצהרת נגישות",
    fullName: "שם מלא",
    type: "סוג",
    registrationDate: "תאריך רישום",
    disability: "מוגבלות",
    residentialAddress: "כתובת מגורים",
    currentAddress: "כתובת נוכחית",
    alerts: "התראות",
    actions: "פעולות",
    all: "הכל",
    volunteer: "מתנדב",
    user: "משתמש",
    welcomeMessage: "ברוכים הבאים לאפליקציית האפוד הסגול של עמותת נגישות ישראל - לסיוע לאנשים עם מוגבלויות במצבי חירום. כאן תוכלו לסייע לאנשים עם מוגבלויות בכל רחבי הארץ. העזרה שלכם תסייע רבות למשימת האפוד הסגול - לא להשאיר אף אחד מאחור!",
    enterPhoneNumber: "הזן מספר טלפון לקבלת קוד ב-SMS",
    enterVerificationCode: "הזן את קוד האימות",
    verifyCode: "אמת קוד",
    getCode: "קבל קוד",
    registerAs: "הרשם כ",
    clear: "נקה",
    editingMyProfile: "ערוך את הפרופיל שלי",
    exitFromSystem: "יציאה מהמערכת",
    refresh: "רענן",
    disableCategoryOption: "השבת אפשרות קטגוריית עזרה למטה ידוע כי בקשת הקטגוריה שלך כבר בתהליך או פתוחה",
    chooseHelpType: "כדי להתחיל, בחר את סוג העזרה שאתה מבקש",
    toNextStep: "לשלב הבא",
    nextStep: "שלב הבא",
    needRideTo: "אני צריך הסעה ל",
    iAmFrom: "אני מ",
    originAddressLonger: "כתובת המקור שלך חייבת להיות ארוכה מ-5 תווים.",
    destinationAddressLonger: "כתובת היעד שלך חייבת להיות ארוכה מ-5 תווים.",
    wantToBeThereOn: "אני רוצה להיות שם בתאריך",
    selectFutureDate: "נא לבחור תאריך עתידי.",
    requestDetailsDescription: "פרטים ותיאור הבקשה",
    descriptionLonger: "התיאור שלך חייב להיות ארוך מ-5 תווים.",
    untilRequestRelevant: "עד מתי הבקשה רלוונטית",
    personalDetails: "פרטים אישיים",
    fullNameLonger: "שמך המלא חייב להיות ארוך מ-5 תווים.",
    phoneLonger: "מספר הטלפון שלך חייב להיות ארוך מ-5 תווים.",
    residentialAddressLonger: "כתובת המגורים שלך חייבת להיות ארוכה מ-5 תווים",
    createNewHelpRequest: "צור בקשת עזרה חדשה",
    enterValidPhoneNumber: "הכנס מספר טלפון תקין",
    sentTo: "נשלח אל",
    date: "תאריך",
    time: "זמן",
    channel: "ערוץ",
    content: "תוכן",
    usePrevious: "השתמש קודם",
    useCurrent: "השתמש נוכחי",
    status: "סטטוס",
    sendTo: "שלח אל",
    category: "קטגוריה",
    pendingApplicationUserRequestManagement: "ניהול בקשות משתמשים ממתינים",
    perPage: "לפי עמוד",
    arrivalAddress: "כתובת הגעה",
    wayForCommunication: "דרך תקשורת מועדפת",
    whatsApp: "וואטסאפ",
    welcomeDashboard: "ברוך הבא ללוח המחוונים",
    iNeedARideTo: "אני צריך הסעה ל",
    iWantToBeThereOn: "אני רוצה להיות שם בתאריך",
    at: "בשעה",
    detailsAndDescriptionOfRequest: "פרטים ותיאור הבקשה",
    toTheNextStep: "לשלב הבא",
    referenceDescription: "תיאור הפניה",
    comments: "הערות",
    relevantUntil: "רלוונטי עד",
    sorryICantHelpThisTime: "מצטער, אני לא יכול לעזור הפעם",
    imReadyAccept: "אני מוכן לקבל",
    appliedFilters: "סינונים שהוחלו",
    filtering: "מסנן",
    showVolunteers: "הצג מתנדבים",
    cancel: "בטל",
    byCategory: "לפי קטגוריה",
    byTown: "לפי עיר",
    accessibilityAndDisabilityInfo: "מידע על נגישות וצרכי נכות",
    goBack: "חזור",
    details: "פרטים",
    youCanContactMeAt: "תוכל ליצור איתי קשר ב",
    deletedSuccessMsg: "נמחק בהצלחה",
    yes: "כן",
    no: "לא",
    registerToHelp: "הרשם לסייע",
    joinUs: "הצטרף אלינו",
    role: "תפקיד",
    switchAs: "החלף כ",
    submit: "שלח",
    updateRoleMsg: "התפקיד עודכן בהצלחה",
    scheduledTasks: "משימות מתוזמנות",
    settings: "הגדרות",
    Please_enter_your_email: "אנא הזן את האימייל שלך ",
    Please_enter_your_password: "אנא הזן את הסיסמה שלך ",
    Forgot_password: "שכחת סיסמה?",
    Remember_me: "זכור אותי",
    Click_here: "לחץ כאן",
    name: "שם",
    client_id: "מזהה לקוח",
    client_secret: "סוד הלקוח",
    tenant_id: "מזהה שוכר",
    addnew: "הוסף חדש",
    services: "שירותים",
    Please_enter_your_organization_name: "אנא הזן את שם הארגון ",
    Summary_Description: "תיאור סיכום",
    Please_enter_summary_description: "נא להזין תיאור סיכום",
    Please_enter_your_client_id: "אנא הזן את מזהה הלקוח שלך ",
    Please_enter_your_client_secret: "אנא הזן את הסוד של הלקוח שלך ",
    Please_enter_your_tenant_id: "אנא הזן את מזהה השוכר שלך ",
    Please_select_your_service: "אנא בחר את השירות שלך ",
    Submit: "שלח",
    Cancel: "ביטול",
    dataSaved: "ברכות! שמרנו את הנתונים שלך!",
    dataSavedTitle: "הנתונים נשמרו",
    dataUpdated: "ברכות! הנתונים שלך עודכנו!",
    dataUpdatedTitle: "הנתונים עודכנו",
    organizationDeactivatedSuccess: "הארגון הופסק בהצלחה",
    organizationActivatedSuccess: "הארגון הופעל בהצלחה",
    organizationNameRequired: "שם הארגון חייב להיות מיתר",
    organizationNameMinLength: "שם הארגון חייב להיות לפחות 3 תווים",
    serviceRequired: "אנא בחר שירות",
    clientIdRequired: "מזהה הלקוח דרוש",
    clientIdValid: "מזהה הלקוח חייב להיות מיתר ואינו ריק",
    clientSecretValid: "סוד הלקוח חייב להיות מיתר ואינו ריק",
    tenantIdRequired: "מזהה שוכר דרוש",
    tenantIdValid: "מזהה שוכר חייב להיות מיתר ואינו ריק",
    deleteItem: "האם אתה בטוח שברצונך למחוק פריט זה?",
    confirmDeletion: "אישור מחיקה",
    EnterTaskName: "אנא הזן שם משימה",
    TaskNameMinLength: "שם המשימה חייב להיות לפחות 3 תווים",
    TaskNameIsRequired: "שדה שם המשימה הוא שדה חובה",
    EnterTaskdescription: "אנא הזן תיאור משימה",
    Daily: "יומי",
    Hourly: "שַׁעַת",
    SelectFrequency: "אנא בחר תדירות",
    EnterStartTime: "אנא בחר זמן התחלה",
    EnterEndTime: "אנא בחר זמן סיום",
    EnterDescription: "אנא הוסף תיאור",
    EnterEmail: "אנא הזן אימייל",
    start_time: "זמן התחלה",
    startTimeRequired: "זמן התחלה הוא שדה חובה",
    descriptionRequired: "תיאור הוא שדה חובה",
    TaskNameRequired: "שם משימה הוא שדה חובה",
    descriptionMinLength: "התיאור חייב להיות לפחות 10 תווים",
    invalidTimeFormat: "פורמט זמן לא תקין. אנא השתמש בפורמט HH:MM",
    endTimeRequired: "זמן סיום הוא שדה חובה",
    endTimeGreaterThanStartTime: "זמן סיום חייב להיות גדול יותר מזמן התחלה",
    emailRequired: "אימייל הוא שדה חובה",
    invalidEmail: "פורמט אימייל לא תקין",
    UpdatescheduledTasks: "עדכון משימות מתוזמנות",
    ScheduledTaskDeletedTitle: "המשימה המתוזמנת נמחקה",
    ScheduledTaskDeletedMessage: "המשימה המתוזמנת נמחקה בהצלחה",
    TaskDeactivatedTitle: "המשימה בוטלה",
    TaskDeactivatedMessage: "המשימה בוטלה בהצלחה",
    TaskActivatedTitle: "המשימה הופעלה",
    TaskActivatedMessage: "המשימה הופעלה בהצלחה",
    SelectStatus: "בחר סטטוס",
    Active: "פעיל",
    Inactive: "לא פעיל",
    statusRequired: "אנא בחר סטטוס",
    Integrations: "אינטגרציות",
    confirmDeletionIntegrations: "מחק אינטגרציה",
    deleteItemIntegrations: "האם אתה בטוח שברצונך למחוק את האינטגרציה הזו?",
    addIntegrations: "הוסף אינטגרציה",
    Users: "משתמשים",
    integrationsDeletedSuccess: "האינטגרציה נמחקה בהצלחה",
    integrationsDeleted: "האינטגרציה נמחקה",
    integrationsActivated: "האינטגרציה הופעלה",
    integrationsActivatedSuccess: "האינטגרציה הופעלה בהצלחה",
    integrationsDeactivated: "האינטגרציה הושבתה",
    integrationsDeactivatedSuccess: "האינטגרציה הושבתה בהצלחה",
    confirmDeletionUsers: "האם אתה בטוח שברצונך למחוק את המשתמש הזה?",
    deleteItemUsers: "המשתמש נמחק בהצלחה",
    usersDeleted: "המשתמש נמחק",
    usersDeletedSuccess: "המשתמש נמחק בהצלחה",
    usersActivated: "המשתמש הופעל",
    usersActivatedSuccess: "המשתמש הופעל בהצלחה",
    usersDeactivated: "המשתמש בוטל",
    usersDeactivatedSuccess: "המשתמש בוטל בהצלחה",
    confirmDeleteUsers: "מחק את המשתמש",
    addUsers: "הוסף משתמשים",
    endTimeGreater: "זמן הסיום חייב להיות גדול יותר מזמן ההתחלה",
    full_name: "שם מלא",
    SelectRole: "אנא בחר תפקיד",
    Please_enter_your_full_name: "אנא הזן את שמך המלא",
    Please_enter_your_phone: "אנא הזן את מספר הטלפון שלך",
    Please_enter_your_Password: "אנא הזן את הסיסמה שלך",
    phoneRequired: "שדה מספר הטלפון חובה",
    invalidPhone: "מספר הטלפון לא תקין",
    passwordMinLength: "הסיסמה חייבת להיות באורך של לפחות 8 תווים",
    passwordMismatch: "הסיסמאות אינן תואמות",
    Confirm_your_Password: "אשר את הסיסמה שלך",
    UserdataSavedTitle: "נתוני המשתמש נשמרו",
    UserdataSaved: "מזל טוב! שמרנו את נתוני המשתמש שלך!",
    confirmDeletionTask: "מחק משימה מתוזמנת",
    deleteTask: "האם אתה בטוח שברצונך למחוק את המשימה המתוזמנת הזו?",
    ConfirmSubmission: "אישור שליחה",
    ConfirmTaskName: "שם המשימה",
    ConfirmTaskDescription: "תיאור המשימה",
    ConfirmStartTime: "זמן התחלה",
    ConfirmEndTime: "זמן סיום",
    ConfirmEmail: "אימייל",
    ConfirmStatus: "סטטוס",
    Confirm: "אשר",
    TaskLogs: "יומני משימות",
    AddTaskLogs: "הוסף יומני משימות",
    task_id: "מזהה משימה",
    task_name: "שם משימה",
    recipient: "נמען",
    TaskLogDeactivatedTitle: "יומן משימה לא פעיל",
    TaskLogActivatedTitle: "יומן משימה פעיל",
    TaskLogDeactivatedMessage: "יומן המשימה הופסק.",
    TaskLogActivatedMessage: "יומן המשימה הופעל.",
    TaskLogDeletedTitle: "יומן משימה נמחק",
    TaskLogDeletedMessage: "יומן המשימה נמחק.",
    confirmDeletionTaskLog: "האם אתה בטוח שברצונך למחוק את יומן המשימה הזה",
    deleteTaskLog: "פעולה זו תמחק את יומן המשימה לצמיתות.",
    Please_select_recipient: "אנא בחר נמען.",
    Please_select_Task: "אנא בחר משימה.",
    Task_Name: "שם משימה",
    data: "נתונים",
    azure_end_point: "נקודת קצה של Azure",
    azure_token: "אסימון Azure",
    azure_api_token: "אסימון API של Azure",
    azure_api_version: "גרסת API של Azure",
    grant_type: "סוג הרשאה",
    username: "שם משתמש",
    password: "סיסמה",
    keep_me_logged_in:"השאר אותי מחובר",
    security_token: "אסימון אבטחה",
    instance_url: "כתובת URL של מופע",
    notion_database_id: "מזהה מסד נתונים של Notion",
    notion_secret: "מפתח סודי של Notion",
    google_client_id: "מזהה לקוח של Google",
    google_client_secret: "סוד לקוח של Google",
    google_redirect_uri: "כתובת הפניה מחדש של Google",
    google_service_account_credentials_json: "אישורי חשבון שירות של Google (JSON)",
    TextCopySuccessfully: "הטקסט הועתק בהצלחה",
    TextCopied: "הטקסט הועתק",
    microsoft_client_id: "מזהה לקוח של מיקרוסופט",
    microsoft_client_secret: "סוד לקוח של מיקרוסופט",
    microsoft_tenant_id: "מזהה דייר של מיקרוסופט",
    url: "כתובת אתר",
    method: "שיטה",
    request_payload: "נתוני בקשה",
    response_payload: "נתוני תגובה",
    status_code: "קוד סטטוס",
    service_id: "מזהה שירות",
    user_id: "מזהה משתמש",
    created_at: "נוצר ב",
    ApiLogs: "יומני API",
    Office365Users: "משתמשי Office365",
    integration_id: "מזהה אינטגרציה",
    microsoft_user_id: "מזהה משתמש Microsoft",
    user_principal_name: "שם משתמש עיקרי",
    preferred_language: "שפה מועדפת",
    office_location: "מיקום משרד",
    job_title: "תפקיד",
    surname: "שם משפחה",
    given_name: "שם פרטי",
    Inbox: "דואר נכנס",
    from: "מאת",
    to: "אל",
    subject: "נושא",
    ShowMail: "הצג דואר",
    view_details: "הצג פרטים",
    Insights: "תובנות",
    AddInsights: "הוסף תובנות",
    UpdateInsights: "עדכן תובנות",
    product_service: "מוצר / שירות Salesforce",
    CRM: "CRM",
    Analytics: "אנליטיקה",
    Net_Zero_Cloud: "Net Zero Cloud",
    Financial_Services_Cloud: "Financial Services Cloud",
    Communications_Cloud: "Communications Cloud",
    Education_Cloud: "Education Cloud",
    clickHere: "לחץ כאן",
    error: "שגיאה",
    serviceNotSupported: "השירות אינו נתמך",
    SalesforceUsers: "משתמשי Salesforce",
    GsuitUsers: "משתמשי G-Suite",
    DomainAdminEmail: "אימייל מנהל דומיין",
    DomainName: "שם דומיין",
    view_existing_credentials: "הצג אישורים קיימים",
    billing_address: "כתובת לחיוב",
    crm_account_id: "מזהה חשבון CRM",
    shipping_address: "כתובת למשלוח",
    SalesforceCrmUsers: " Salesforce CRM",
    SalesforceEducationCloudUsers: " Salesforce Education Cloud",
    SalesforceAnalyticsUsers: " Salesforce Analytics",
    SalesforceNetZeroCloudUsers: " Salesforce Net Zero Cloud",
    SalesforceFinancialServicesCloudUsers: " Salesforce Financial Services Cloud",
    SalesforceCommunicationsCloudUsers: " Salesforce Communications Cloud",
    communications_account_id: "מזהה חשבון Communications",
    site: "אתר",
    billing_state: "מדינת חיוב",
    owner_id: "מזהה בעלים",
    owner_alias: "כינוי בעלים",
    analytics_report_id: "מזהה דוח Analytics",
    folder_name: "שם תיקייה",
    developer_name: "שם מפתח",
    format: "פורמט",
    financial_account_id: "מזהה חשבון פיננסי",
    financial_account_number: "מספר חשבון פיננסי",
    source_system_identifier: "מזהה מערכת מקור",
    product_id: "מזהה מוצר",
    branch_unit_id: "מזהה סניף",
    banker_id: "מזהה בנקאי",
    credit_limit: "מגבלת אשראי",
    annual_emissions_inventory_id: "מזהה מלאי פליטות שנתי",
    total_scope_1_emissions: "סך פליטות תחום 1",
    total_scope_2_emissions: "סך פליטות תחום 2",
    total_scope_3_emissions: "סך פליטות תחום 3",
    total_emissions: "סך כל הפליטות",
    final_emission_in_tco2e: "פליטה סופית ב-tCO2e",
    api_access_token: "אסימון גישה ל-API",
    run: "לָרוּץ",
    runNow: "הרץ עכשיו",
    TaskRunSuccess: "המשימה בוצעה בהצלחה.",
    TaskRunMessage: "המשימה המתוזמנת בוצעה בהצלחה.",
    TaskRunError: "ביצוע המשימה נכשל.",
    TaskRunErrorMessage: "אירעה שגיאה במהלך ביצוע המשימה.",
    contacts: "אנשי קשר",
    deals_value: "ערך עסקאות",
    title: "כּוֹתֶרֶת",
    priority: "עֲדִיפוּת",
    company: "חֶברָה",
    integration: "הִשׁתַלְבוּת",
    crmContacts: "אנשי קשר CRM",
    crmDeals: "עסקאות CRM",
    crmLeads: "לידים ב-CRM",
    crmAccounts: "חשבונות CRM",
    crmClientProjects: "פרויקטים של לקוחות CRM",
    crmActivities: "פעילויות CRM",
    deals: "עסקאות",
    AuditTrail: "יומן ביקורת",
    Model: "מודל",
    monday: "יום שני",
    owner: "בעלים",
    value: "ערך",
    close_date: "תאריך סגירה",
    expected_close_date: "תאריך סגירה צפוי",
    close_probability: "הסתברות לסגירה",
    forecast_value: "ערך תחזית",
    last_interation: "אינטראקציה אחרונה",
    active_sequence: "רצף פעיל",
    location: "מיקום",
    domain: "דומיין",
    employee_count: "מספר עובדים",
    company_profile: "פרופיל חברה",
    headquarter_location: "מיקום המטה",
    timeline: "ציר זמן",
    file: "קובץ",
    stage: "שלב",
    sync_status: "סטטוס סנכרון",
    leads: "לידים",
    accounts: "חשבונות",
    Activities: "פעילויות",
    ClientProject: "פרויקט לקוח",
    expand: "לְהַרְחִיב",
    people: "אֲנָשִׁים",
    hide: "לְהַסתִיר",
    show: "לְהַצִיג",
    year: "שָׁנָה",
    ZOHO: "Zoho",
    ZohoAccounts: "חשבונות Zoho",
    ZohoDeals: "עסקאות Zoho",
    ZohoLeads: "לידים Zoho",
    ZohoPurchaseOrder: "הזמנת רכש Zoho",
    ZohoSalesOrder: "הזמנת מכירה Zoho",
    account_number: "מספר חשבון",
    account_type: "סוג חשבון",
    industry: "תעשייה",
    annual_revenue: "הכנסה שנתית",
    employees: "עובדים",
    website: "אתר אינטרנט",
    fax: "פקס",
    crm_deal_id: "מזהה עסקה CRM",
    deal_name: "שם עסקה",
    amount: "סכום",
    currency: "מטבע",
    probability: "הסתברות",
    expected_revenue: "הכנסה צפויה",
    closing_date: "תאריך סגירה",
    expected_closing_date: "תאריך סגירה צפוי",
    lead_source: "מקור ליד",
    campaign_source: "מקור קמפיין",
    loss_reason: "סיבת הפסד",
    crm_lead_id: "מזהה ליד CRM",
    lead_owner: "בעל ליד",
    first_name: "שם פרטי",
    last_name: "שם משפחה",
    designation: "תפקיד",
    lead_status: "סטטוס ליד",
    purchase_order_id: "מזהה הזמנת רכש",
    purchase_order_number: "מספר הזמנת רכש",
    vendor_name: "שם ספק",
    po_date: "תאריך הזמנה",
    expected_delivery_date: "תאריך אספקה צפוי",
    total: "סה״כ",
    grand_total: "סה״כ כולל",
    sub_total: "סכום ביניים",
    tax: "מס",
    discount: "הנחה",
    round_off_amount: "עיגול סכום",
    adjustment: "התאמה",
    sales_order_id: "מזהה הזמנת מכירה",
    sales_order_number: "מספר הזמנת מכירה",
    billing_street: "רחוב לחיוב",
    shipping_street: "רחוב למשלוח",
    number_of_employees: "מספר עובדים",
    chatAi: "צ'אט AI",
    rakoonChat: "רקון צ'אט",
    chatWithRakoonAi: "צ'אט עם Rakoon AI",
    failure_reason: "סיבת כשל",
    rakoon: "רקון",
    typeYourMessageHere: "הקלד את הודעתך כאן...",
    api: "ממשק תכנות יישומים",
    userHistory: "היסטוריית משתמש",
    users: "משתמשים",
    select: "לִבחוֹר",
    syncManually: "סנכרון ידני",
    viewApiLog: "הצג יומן API",
    inputFieldChangedMessage: "יש לך שינויים שלא נשמרו. האם אתה רוצה להמשיך?",
    continue: "לְהַמשִׁיך",
    syncStarted: "הסנכרון החל",
    syncInitiated: "תהליך הסנכרון החל בהצלחה.",
    syncFailed: "נכשל בניסיון להתחיל סנכרון. אנא נסה שוב.",
    syncCompleted: "הסנכרון הושלם",
    syncFinished: "הסנכרון הסתיים",
    syncDateTime: "סנכרון DateTime",
    monday_id: 'זיהוי יום שני',
    newChat: "צ'אט חדש",
    deleteChatConfirmMessage: "האם אתה בטוח שברצונך למחוק?",
    showUser: "הצג משתמש",
    Back: "חזרה",
    gender: "מגדר",
    birth_date: "תאריך לידה",
    employee_id: "זיהוי עובד",
    Employees: "עובדים",
    business_partner: "שותף עסקי",
    business_partner_uuid: 'מזהה ייחודי',
    created_by_user: 'נוצר על ידי משתמש',
    search_term1: 'מונח חיפוש 1',
    created_by: 'נוצר על ידי',
    account_id: 'מזהה חשבון',
    campaign_type: 'סוג מסע פרסום',
    start_date: 'תאריך התחלה',
    entity_last_changed_on: 'שונה לאחרונה',
    campaign: 'מסעות פרסום',
    customers: 'לקוחות',
    customer_id: 'זיהוי לקוח',
    changed_by: 'שונה מזהה',
    postal_address: 'כתובת דואר',
    time_zone: 'אזור זמן',
    partners: 'שותפים',
    partner_id: 'זיהוי שותף',
    promotions: 'מבצעים',
    objective_text: 'טקסט מטרה',
    promotion_type: 'סוג קידום',
    employee_responsible: 'עובד אחראי',
    products: 'מוצרים',
    product_category_id: 'מזהה קטגוריית מוצר',
    base_uom: 'יחידת מידה בסיסית',
    businessusers: "משתמשים עסקיים",
    object_id: "מזהה אובייקט",
    etag: "תגית E",
    employee_uuid: "מזהה ייחודי של עובד",
    technical_user_id: "מזהה משתמש טכני",
    identity_uuid: "מזהה זהות",
    business_partner_name: "שם שותף עסקי",
    department_name: "שם מחלקה",
    company_name: "שם חברה",
    manager_name: "שם מנהל",
    email_uri: "כתובת אימייל",
    decimal_format_code: "קוד פורמט עשרוני",
    decimal_format_code_text: "טקסט פורמט עשרוני",
    date_format_code: "קוד פורמט תאריך",
    date_format_code_text: "טקסט פורמט תאריך",
    time_format_code: "קוד פורמט שעה",
    time_format_code_text: "טקסט פורמט שעה",
    time_zone_code: "קוד אזור זמן",
    time_zone_code_text: "טקסט אזור זמן",
    logon_language_code: "קוד שפת התחברות",
    logon_language_code_text: "טקסט שפת התחברות",
    user_validity_start_date: "תאריך תחילת תוקף משתמש",
    user_validity_end_date: "תאריך סיום תוקף משתמש",
    user_locked_indicator: "מחוון נעילת משתמש",
    user_counted_indicator: "מחוון ספירת משתמש",
    password_policy_code: "קוד מדיניות סיסמה",
    password_inactive_indicator: "מחוון סיסמה לא פעילה",
    password_locked_indicator: "מחוון סיסמה נעולה",
    user_account_type_code: "קוד סוג חשבון משתמש",
    user_account_type_code_text: "טקסט סוג חשבון משתמש",
    created_on: "נוצר בתאריך",
    user_created_by: "נוצר על ידי משתמש",
    user_changed_by: "שונה על ידי משתמש",
    contects: "אנשי קשר",
    api_key: "מפתח API",
    base_url: "כתובת בסיסית",
    SelectLimit: "בחר מגבלה",
    summaryDescriptionRequired: "תיאור סיכום הוא שדה חובה",
    summaryDescriptionMinLength: "תיאור הסיכום חייב להיות לפחות 10 תווים",
    Zoho_CRM: "Zoho CRM",
    hideSuggestedQuestions: "הסתר שאלות מוצעות",
    showSuggestedQuestions: "הצג שאלות מוצעות",
    aiIndex: "מדד בינה מלאכותית",
    automatic: "אוטומטי",
    rakoonSap: "רקון SAP",
    rakoonSalesforceMonday: "רקון Salesforce Monday",
    rakoonOfficeGsuite: "רקון Office GSuite",
    rakoonNotion: "רקון Notion",
    userOrganization: "משתמשים וארגון",
    emailCommunication: "אימייל ותקשורת",
    securityCompliance: "אבטחה ותאימות",
    dataAnalysis: "ניתוח נתונים",
    searchQuestions: "חפש שאלות...",
    index: "מדד",
    scheduled_type: "סוג מתוזמן",
    end_time: "זמן סיום",
    description: "תיאור",
    frequencyRequired: "תדירות היא שדה חובה",
    evaluating: "מעריך...",
    evaluateInsight: "הערך תובנה",
    suggestionsToImprove: "הצעות לשיפור התובנה שלך",
    improvedPrompt: "פקודה משופרת",
    yesUpdateIt: "כן, עדכן את זה",
    pleaseFixErrorsBeforeSubmitting: "אנא תקן את השגיאות לפני השליחה",
    pleaseFixErrorsAndTryAgain: "אנא תקן את השגיאות ונסה שוב",
    somethingWentWrong: "משהו השתבש. אנא נסה שוב",
    failedToImproveInsight: "נכשל בשיפור התובנה. אנא נסה שוב",
    loading: "טוען...",
    close: "סגור",
    statistics: "סטטיסטיקות",
    hello: "שלום",
    myInsights: "התובנות שלי",
    addInsights: "הוסף תובנות",
    addIntegration: "הוסף אינטגרציה",
    systemUsers: "משתמשי מערכת",
    addUser: "הוסף משתמש",
    last7Days: "7 הימים האחרונים",
    last30Days: "30 הימים האחרונים",
    insightsOverTime: "תובנות לאורך זמן",
    azureStorageOverTime: "אחסון Azure לאורך זמן",
    rakoonPrompts: "פקודות רקון",
    done: "הושלם",
    failed: "נכשל",
    promptsSent: "פקודות שנשלחו",
    insightsDelivered: "תובנות שנמסרו",
    aiThinking: "חושב...",
    aiSearching: "מחפש נתונים...",
    aiCompiling: "מקבץ מידע...",
    aiAnalyzing: "מנתח תוצאות...",
    aiGenerating: "יוצר תגובה...",
    aiFinalizing: "מסיים...",
    rakoonaiFindingSources: "RakoonAI מאתר את מקורות הנתונים הרלוונטיים לשאלה שלך.",
    rakoonaiCompilingAnswer: "RakoonAI מקבץ תשובה עבורך.",
    rakoonaiAnalyzingResults: "RakoonAI מנתח את התוצאות.",
    rakoonaiComposingAnswer: "RakoonAI יוצר את התשובה שלך.",
    rakoonaiFinalizing: "מסיים את התשובה.",
    rakoonaiSearchingIn: "מחפש ב",
    rakoonaiFoundIn: "נמצאו תוצאות ב",
    rakoonaiFoundSources: "מקורות שנבחרו",
    searchingIn: "מחפש ב",
    foundResultsIn: "נמצאו תוצאות ב",
    noResultsFoundIn: "לא נמצאו תוצאות ב",
    automaticRoutingFailed: "הניתוב האוטומטי לא החזיר מדדים לחיפוש",
    errorInStoreMethod: "שגיאה בשיטת האחסון",

};

export default {
    locale: "he-IL",
    messages: {
        title: titles
    },
};
